import { APIClient } from '../helpers/api_helper';

const api = new APIClient();
export const getVehicles = (params?: object) => {
  const apiUrl = `vehicles/`;
  return api.get(apiUrl, params);
};

export default getVehicles;
